// This component has been added ad-hoc by coaching-fe team: https://private.hubteam.com/janus/groups/hs-coaching-fe
// For any questions/concerns, please use Slack channel: #coaching-fe

import { useCallback, useContext, useMemo } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { LockBadge } from 'foundations-components/transitional/components/LockBadge';
import { useUpgradeModal } from 'ui-addon-upgrades/ums/useUpgradeModal';
import SegmentationFiltersInstanceContext from '../../../../state/SegmentationFiltersInstanceContext';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TranscriptUpgradePlaceholder = () => {
  const {
    hasLimit
  } = useContext(SegmentationFiltersInstanceContext);
  const hasServiceStarterSeats = !!hasLimit('service-starter-seats');
  const hasSalesStarterSeats = !!hasLimit('sales-starter-seats');
  const upgradeModalKey = hasServiceStarterSeats && !hasSalesStarterSeats ? 'ci-call-index-transcript-quick-filter-service-hub' : 'ci-call-index-transcript-quick-filter-sales-hub';
  const {
    openUpgradeModal
  } = useUpgradeModal(upgradeModalKey);
  const label = useMemo(() => /*#__PURE__*/_jsx(FormattedMessage, {
    message: 'customerDataFiltersUI.quickFiltersBar.transcript.label'
  }), []);
  const renderButtonContent = useCallback(() => /*#__PURE__*/_jsxs(Flex, {
    columnGap: "100",
    children: [/*#__PURE__*/_jsx(LockBadge, {
      size: "100"
    }), /*#__PURE__*/_jsx(TruncateString, {
      maxWidth: 120,
      children: label
    })]
  }), [label]);
  return /*#__PURE__*/_jsx("label", {
    children: /*#__PURE__*/_jsx(UISelect, {
      className: "p-left-1",
      anchorType: "button",
      ButtonContent: renderButtonContent,
      clearable: true,
      "data-selenium-test": "quickfilters-hasTranscript-pql",
      menuWidth: "auto",
      multi: true,
      open: false,
      options: [],
      placeholder: label,
      buttonUse: "transparent"
      // @ts-expect-error `UISelect` component does not have an `onClick` property
      ,
      onClick: openUpgradeModal
    })
  });
};
export default TranscriptUpgradePlaceholder;